export const EXAM_LOADING = 'EXAM_DETAIL::EXAM_LOADING';
export const EXAM_RECEIVE = 'EXAM_DETAIL::EXAM_RECEIVE';
export const EXAM_ERROR = 'EXAM_DETAIL::EXAM_ERROR';
